module.exports = __webpack_public_path__ + "static/point_no_Data_globe.f592af1a.png";